import { Box } from '@material-ui/core';
import React from 'react';
import { Sticky, StickyContainer } from 'react-sticky';

import { CONSTANTS } from '../../../../core/config/constants';
import CompanyTabs from '../CompanyTabs/CompanyTabs';
import HeaderPanel from '../HeaderPanel';

export interface Props {
  companyBlockStyle: string;
}

const CompanyBlock: React.FC<Props> = ({ companyBlockStyle }) => {
  return (
    <StickyContainer className={companyBlockStyle}>
      <HeaderPanel />
      <Sticky topOffset={CONSTANTS.SCROLL_TOP_OFFSET}>
        {({ style }) => (
          <Box style={style}>
            <CompanyTabs />
          </Box>
        )}
      </Sticky>
    </StickyContainer>
  );
};

export default CompanyBlock;
